// ─── CATALOGO SERVIZI ─────────────────────────────────────────────────────────
// Ogni voce ha:
//   id, nome, prezzo, unita (mese | una tantum | anno)
//   tipi: array di tipi cliente che la vedono (DOM, AZ, PA)
//   modalita: "canone" | "vendita" | "entrambi" (per hardware)
//   custom: false (voci del listino)

export const CATEGORIE = {
  connettivita: {
    label: "Connettività",
    icon: "📡",
    tipi: ["DOM", "AZ", "PA"],
    voci: [
      { id: "fibra_dom",    nome: "Fibra FTTH – Piano Casa",                  prezzo: 29.90, unita: "mese",       tipi: ["DOM"],       modalita: "canone" },
      { id: "fibra_biz",    nome: "Fibra FTTH – Piano Business (IP statico)", prezzo: 49.90, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "fibra_pa",     nome: "Fibra FTTH – Piano PA (SLA garantito)",    prezzo: 69.90, unita: "mese",       tipi: ["PA"],        modalita: "canone" },
      { id: "fwa_dom",      nome: "FWA – Piano Casa",                         prezzo: 24.90, unita: "mese",       tipi: ["DOM"],       modalita: "canone" },
      { id: "fwa_biz",      nome: "FWA – Piano Business (IP statico)",        prezzo: 39.90, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "ip_statico",   nome: "IP Pubblico Statico aggiuntivo",           prezzo:  5.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "banda_ded",    nome: "Banda dedicata garantita (upgrade)",       prezzo: 30.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
    ],
  },

  vps: {
    label: "VPS / Hosting",
    icon: "🖥️",
    tipi: ["AZ", "PA"],
    voci: [
      { id: "vps_s",        nome: "VPS Small  (2 vCPU / 4 GB / 80 GB SSD)",  prezzo: 19.90, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "vps_m",        nome: "VPS Medium (4 vCPU / 8 GB / 160 GB SSD)", prezzo: 34.90, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "vps_l",        nome: "VPS Large  (8 vCPU / 16 GB / 320 GB SSD)",prezzo: 59.90, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "backup_vps",   nome: "Backup VPS (Proxmox Backup Server)",       prezzo:  9.90, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "email_biz",    nome: "Business Email Mailcow (10 caselle)",      prezzo: 12.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "obj_storage",  nome: "Object Storage S3 MinIO (100 GB)",         prezzo: 15.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
    ],
  },

  sicurezza: {
    label: "Sicurezza – Studio Sicuro",
    icon: "🔒",
    tipi: ["AZ", "PA"],
    voci: [
      { id: "fwaas_base",   nome: "FWaaS Base (OPNsense gestito)",            prezzo: 39.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "fwaas_pro",    nome: "FWaaS Pro (OPNsense + IDS/IPS + report)",  prezzo: 69.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "vpn_5u",       nome: "VPN Gestita WireGuard (5 utenti)",         prezzo: 25.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "vpn_ext",      nome: "VPN – blocco utenti aggiuntivi (×5)",      prezzo: 10.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "gdpr_assess",  nome: "Consulenza GDPR – assessment iniziale",    prezzo:350.00, unita: "una tantum", tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "gdpr_ret",     nome: "Consulenza GDPR – retainer mensile",       prezzo:120.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
    ],
  },

  msp: {
    label: "Servizi Gestiti (MSP)",
    icon: "⚙️",
    tipi: ["DOM", "AZ", "PA"],
    voci: [
      { id: "msp_dom",      nome: "Assistenza Remota Casa (helpdesk base)",   prezzo: 15.00, unita: "mese",       tipi: ["DOM"],       modalita: "canone" },
      { id: "msp_base",     nome: "MSP Base – monitoraggio & helpdesk",       prezzo: 59.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "msp_pro",      nome: "MSP Pro – monitoraggio + patch + SLA 4h",  prezzo: 99.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "draas",        nome: "DRaaS (disaster recovery PBS + replica)",  prezzo: 49.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
      { id: "vdi",          nome: "VDI Apache Guacamole (3 desktop)",         prezzo: 45.00, unita: "mese",       tipi: ["AZ","PA"],   modalita: "canone" },
    ],
  },

  hardware: {
    label: "Hardware",
    icon: "🔧",
    tipi: ["DOM", "AZ", "PA"],
    voci: [
      // Domestico
      { id: "hw_router_dom",  nome: "Router WiFi 6 (es. MikroTik hAP ax lite)", prezzo: 89.00,  unita: "una tantum", tipi: ["DOM"],     modalita: "entrambi", prezzoNoleggio: 5.00 },
      { id: "hw_extender",    nome: "WiFi Extender / Mesh node",                prezzo: 59.00,  unita: "una tantum", tipi: ["DOM"],     modalita: "entrambi", prezzoNoleggio: 3.00 },
      { id: "hw_ont",         nome: "ONT/Modem FTTH",                           prezzo: 49.00,  unita: "una tantum", tipi: ["DOM"],     modalita: "entrambi", prezzoNoleggio: 2.50 },
      // Aziendale / PA
      { id: "hw_hap_ax3",     nome: "MikroTik hAP ax3 (SOHO router/AP)",       prezzo:139.00,  unita: "una tantum", tipi: ["AZ","PA"], modalita: "entrambi", prezzoNoleggio: 8.00 },
      { id: "hw_rb5009",      nome: "MikroTik RB5009 (router business)",        prezzo:229.00,  unita: "una tantum", tipi: ["AZ","PA"], modalita: "entrambi", prezzoNoleggio:12.00 },
      { id: "hw_fw_desktop",  nome: "Firewall desktop (es. Protectli VP2420)",  prezzo:349.00,  unita: "una tantum", tipi: ["AZ","PA"], modalita: "entrambi", prezzoNoleggio:18.00 },
      { id: "hw_sw_8p",       nome: "Switch gestito 8 porte PoE",               prezzo:159.00,  unita: "una tantum", tipi: ["AZ","PA"], modalita: "entrambi", prezzoNoleggio: 9.00 },
      { id: "hw_sw_24p",      nome: "Switch gestito 24 porte PoE",              prezzo:389.00,  unita: "una tantum", tipi: ["AZ","PA"], modalita: "entrambi", prezzoNoleggio:20.00 },
      { id: "hw_phone_ip",    nome: "Telefono IP (es. Yealink T31P)",           prezzo: 79.00,  unita: "una tantum", tipi: ["AZ","PA"], modalita: "entrambi", prezzoNoleggio: 4.00 },
      { id: "hw_ap_biz",      nome: "Access Point business (es. MikroTik cAP)", prezzo:119.00,  unita: "una tantum", tipi: ["AZ","PA"], modalita: "entrambi", prezzoNoleggio: 6.00 },
      { id: "hw_install",     nome: "Installazione e configurazione on-site",   prezzo:120.00,  unita: "una tantum", tipi: ["DOM","AZ","PA"], modalita: "canone" },
    ],
  },
};

// Helper: restituisce solo le categorie e voci visibili per un tipo cliente
export function getCatalogoPerTipo(tipoCliente) {
  const result = {};
  for (const [catKey, cat] of Object.entries(CATEGORIE)) {
    if (!cat.tipi.includes(tipoCliente)) continue;
    const voci = cat.voci.filter(v => v.tipi.includes(tipoCliente));
    if (voci.length) result[catKey] = { ...cat, voci };
  }
  return result;
}

export const DURATE = ["1 mese", "3 mesi", "6 mesi", "12 mesi", "24 mesi", "36 mesi"];

export const TIPO_CLIENTE = {
  DOM: { label: "Domestico",            short: "DOM", color: "#0f7c4a", bg: "#f0fdf4" },
  AZ:  { label: "Aziendale",            short: "AZ",  color: "#0f2850", bg: "#f0f5ff" },
  PA:  { label: "Pubblica Amministrazione", short: "PA", color: "#6b1a1a", bg: "#fff5f5" },
};
